module.exports = __webpack_public_path__ + "img/030-like.a95db775.svg";